import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { bloqueService } from '../services/bloqueService';

export function useBloque(id: string) {
  return useQuery({
    queryKey: ['bloque', id],
    queryFn: () => bloqueService.get(id),
  });
}

/** Edita el contenido de un bloque (coordinador) y refresca su lectura. */
export function useActualizarBloque(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (contenido: string) => bloqueService.update(id, contenido),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['bloque', id] }),
  });
}
